import { Table, Form } from "react-bootstrap";
import { DefaultSelected } from "src/app/components";
import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import Pacman from "src/app/components/layout/Pacman";
import { IData } from "./BulkNetlinkingUtils";
import { useIntl } from "react-intl";
import { toAbsoluteUrl } from "src/_metronic/helpers";

export interface ISemrushKeywords {
    data?: IData;
    loading: boolean;
    handleSelectedKeyword: (keywords: string) => void;
    frequency: { options: SimpleFormSelectOption[]; onChange(value: string): void };
}
const SemrushKeywords = ({ data, handleSelectedKeyword, loading, frequency }: ISemrushKeywords) => {
    const { formatMessage } = useIntl();
    return (
        <>
            {!loading && data ? (
                <>
                    <div className="netlinkingWrapper">
                        <div className="netlinkingTopWrapper">
                            <div className="formSelectWrapper">
                                <div className={`stepper-item current mb-2`}>
                                    <div className="stepper-wrapper">
                                        <div className="stepper-icon w-40px h-40px">
                                            <i className="stepper-check fas fa-check"></i>
                                            <span className="stepper-number">{1}</span>
                                        </div>
                                        <div className="stepper-label">
                                            <h3 className="stepper-title">
                                                {formatMessage({
                                                    id: "common.stepper.keywordsChose",
                                                })}
                                                <img
                                                    width={128}
                                                    src={toAbsoluteUrl(
                                                        "/media/icons/personal/semrush.png"
                                                    )}
                                                />
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Form.Label>
                                        {formatMessage({ id: "common.field.frequency" })}:
                                    </Form.Label>
                                    <DefaultSelected
                                        isClearable={false}
                                        onChange={frequency.onChange}
                                        value={data.frequency}
                                        options={frequency.options}
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <Table bordered>
                                <thead>
                                    <tr
                                        className={"header-no-Selected"}
                                        onClick={() =>
                                            handleSelectedKeyword(
                                                data.semrushKeywords &&
                                                    data.selectedKeywords?.length ===
                                                        data.semrushKeywords?.length
                                                    ? "REMOVE_KEYWORDS"
                                                    : "ALL_KEYWORDS"
                                            )
                                        }
                                    >
                                        <th>
                                            {data.semrushKeywords && (
                                                <Form.Check
                                                    type="switch"
                                                    checked={
                                                        data.selectedKeywords?.length ===
                                                        data.semrushKeywords?.length
                                                    }
                                                />
                                            )}
                                        </th>
                                        <th>
                                            {formatMessage({
                                                id: "common.field.keywords",
                                            })}
                                        </th>
                                        <th>
                                            {formatMessage({
                                                id: "common.field.volume",
                                            })}
                                        </th>
                                        <th>
                                            {formatMessage({
                                                id: "common.field.keywordDifficultyIndex",
                                            })}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!data.semrushKeywords ? (
                                        <>{data.semrushError}</>
                                    ) : (
                                        <>
                                            {data.semrushKeywords?.map((keywordsData, index) => (
                                                <tr
                                                    key={index}
                                                    onClick={() =>
                                                        handleSelectedKeyword(
                                                            keywordsData.keyword || ""
                                                        )
                                                    }
                                                    className={
                                                        data.selectedKeywords?.includes(
                                                            keywordsData.keyword || ""
                                                        )
                                                            ? "selected"
                                                            : ""
                                                    }
                                                >
                                                    <td>
                                                        <Form.Check
                                                            type="switch"
                                                            checked={data.selectedKeywords?.includes(
                                                                keywordsData.keyword || ""
                                                            )}
                                                            onChange={() => {}}
                                                        />
                                                    </td>
                                                    <td>{keywordsData.keyword}</td>
                                                    <td>{keywordsData.volume}</td>
                                                    <td>{keywordsData.keywordDifficultyIndex}</td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </Table>{" "}
                        </div>
                    </div>
                </>
            ) : (
                <Pacman />
            )}
        </>
    );
};

export default SemrushKeywords;
